import type { IconData } from '@stacksjs/iconify-core'

export const squareShape: IconData = {
  "body": "<rect width=\"20\" height=\"20\" x=\"2\" y=\"2\" fill=\"currentColor\" rx=\"1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default squareShape
